<template>
  <div class="infinitescrolltrigger">
    <div ref="infinitescrolltrigger" class="scroll-trigger text-center">
      <LoadingComponent v-if="isBussy" />
    </div>
  </div>
</template>

<script>
// import PageHeader from "@/components/header/PageHeader";
import LoadingComponent from "../../loading/LoadingComponent.vue";
import "@/mixins";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["isSearching"],
  components: {
    LoadingComponent,
  },
  computed: {
    ...mapGetters(["userWalletBalance"]),

    currentPage: {
      get() {
        return this.$store.state.userWalletBalanceCurrentPage;
      },

      set(value) {
        return (this.$store.state.userWalletBalanceCurrentPage = value);
      },
    },

    totalPage: {
      get() {
        return this.$store.state.userWalletBalanceTotalPage;
      },

      set(value) {
        return (this.$store.state.userWalletBalanceTotalPage = value);
      },
    },
  },

  data() {
    return {
      isBussy: false,
      totalPages: 2,
    };
  },

  methods: {
    ...mapActions(["fetchMoreWalletBalance", "saveMoreWalletBalance"]),

    scrollTrigger: function () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.intersectionRatio > 0 &&
            this.currentPage < this.totalPage &&
            this.userWalletBalance.length > 0
          ) {
            this.isBussy = true;
            this.currentPage += 1;
            this.fetchBalance(this.currentPage);
          }
        });
      });

      observer.observe(this.$refs.infinitescrolltrigger);
    },

    fetchBalance: function (currentPage) {
      // console.log(payload);

      this.fetchMoreWalletBalance(currentPage)
        .then((response) => {
          this.isBussy = false;
          // console.log(response.data);
          // console.log(response.data.data);
          if (!response.error) {
            this.saveMoreWalletBalance(response.data.data);

            this.currentPage = response.data.meta.page;
            this.totalPage = response.data.meta.pages;
          }
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.scrollTrigger();
  },
};
</script>
<style scoped>
.infinitescrolltrigger {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scroll-trigger {
  margin-top: 0px;
  text-align: center;
}

[class*="loader"]:before {
  content: "fetching more...";
}
</style>
